import { Component, input, InputSignal } from '@angular/core';


@Component({
  selector: 'app-regimen-empty-state',
  templateUrl: './regimen-empty-state.component.html',
  standalone: true,
  imports: [],
})
export class RegimenEmptyStateComponent {
  iconSrc: InputSignal<string> = input();
  iconClass: InputSignal<string> = input('');
  isRouteView: InputSignal<boolean> = input(false);
}
